const ContentH2Description = (props) => {
  return(
    <div className="px-4 py-2">
      {props.text}
    </div>
  )
}
export default ContentH2Description;